import React from "react";
import PropTypes from "prop-types";
import { Box, Card, Grid, Stack, Typography } from "@mui/material";

export function PageShellHeader({ title, subtitle, actions }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        <Grid item xs={12} md>
          {title ? (
            <Typography
              sx={{
                fontSize: { xs: "1.55rem", md: "1.9rem" },
                fontWeight: 700,
                letterSpacing: "-0.03em",
                color: "#10284f",
                mb: subtitle ? 0.75 : 0,
              }}
            >
              {title}
            </Typography>
          ) : null}

          {subtitle ? (
            <Typography
              sx={{
                fontSize: "0.95rem",
                lineHeight: 1.7,
                color: "#62708a",
                maxWidth: 760,
              }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Grid>

        {actions ? (
          <Grid item xs={12} md="auto">
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
              {actions}
            </Stack>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}

PageShellHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
};

PageShellHeader.defaultProps = {
  title: null,
  subtitle: null,
  actions: null,
};

export function SectionCard({ title, subtitle, children, contentSx }) {
  return (
    <Card
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: "22px",
        border: "1px solid #f1eaea",
        boxShadow: "0 10px 24px rgba(16, 40, 79, 0.04)",
        background: "#fff",
        ...contentSx,
      }}
    >
      {(title || subtitle) && <PageShellHeader title={title} subtitle={subtitle} />}
      {children}
    </Card>
  );
}

SectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  contentSx: PropTypes.object,
};

SectionCard.defaultProps = {
  title: null,
  subtitle: null,
  children: null,
  contentSx: {},
};

export default function PageShell({ title, subtitle, children, actions }) {
  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 3 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
        }}
      >
        <PageShellHeader title={title} subtitle={subtitle} actions={actions} />
        {children}
      </Box>
    </Box>
  );
}

PageShell.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
};

PageShell.defaultProps = {
  title: null,
  subtitle: null,
  children: null,
  actions: null,
};
